import { type FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { AuthShell } from '@/components/shared/Placeholders';
import { ROUTES } from '@/constants/routes';
import { useUserAuth } from '@/context/UserAuthContext';

export function RegisterPage() {
  const navigate = useNavigate();
  const { register, isLoading, clearError } = useUserAuth();
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
  });

  function updateField(field: keyof typeof form, value: string) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    clearError();
    try {
      await register(form);
      navigate(ROUTES.dashboard);
    } catch {
      // handled in context
    }
  }

  return (
    <AuthShell
      title="Create your account"
      subtitle="Join as a subscriber — upgrade to agent anytime"
      loading={isLoading}
      loadingLabel="Creating account..."
      footer={
        <>
          Already have an account?{' '}
          <Link to={ROUTES.login} className="font-semibold text-primary hover:underline">
            Login
          </Link>
        </>
      }
    >
      <form onSubmit={(e) => void handleSubmit(e)} className="space-y-4">
        <div className="grid gap-4 sm:grid-cols-2">
          <Input label="First name" value={form.firstName} onChange={(e) => updateField('firstName', e.target.value)} required />
          <Input label="Last name" value={form.lastName} onChange={(e) => updateField('lastName', e.target.value)} required />
        </div>
        <Input label="Email" type="email" value={form.email} onChange={(e) => updateField('email', e.target.value)} required />
        <Input label="Phone number" value={form.phone} onChange={(e) => updateField('phone', e.target.value)} required />
        <Input
          label="Password"
          type="password"
          value={form.password}
          onChange={(e) => updateField('password', e.target.value)}
          placeholder="6–12 characters"
          required
        />

        <Button type="submit" fullWidth loading={isLoading} loadingText="Creating account...">
          Create account
        </Button>
      </form>
    </AuthShell>
  );
}
